










import { EVENTS } from '@empathybroker/ebx-gluon';
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class CdlFacetsTitle extends Vue {
  closePanel() {
    this.$x.emit(EVENTS.TogglePanel, 'all-facets');
  }
}
